import { forwardRef } from 'react'

import { SystemIconTemplate } from '../../template/system-icon-template'
import { IconProps } from '../../types/types'

export const ArrowUpSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<SystemIconTemplate ref={ref} {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.7796 14.7859C19.0646 14.5284 19.0643 14.0809 18.7789 13.824L12.6691 8.32253C12.2888 7.98004 11.7112 7.98004 11.3309 8.32253L5.28436 13.767C4.96515 14.0545 4.96475 14.5549 5.2835 14.8429C5.55929 15.092 5.97887 15.092 6.25466 14.8429L11.6648 9.95564C11.8552 9.78368 12.1448 9.78368 12.3352 9.95564L17.6822 14.7859C17.9939 15.0674 18.468 15.0674 18.7796 14.7859Z"
				fill="currentColor"
			/>
		</SystemIconTemplate>
	)
})
